import { ExtendedOrderCache } from '../../../lib/cache/ExtendedOrderCache';
import { authenticatedFetchWithTenantAnalytics, useAnalytics, useTenant } from '@parcel2go/npm-p2g-app';
import { useAuth } from 'react-oidc-context';
import { SettingsCache } from '~/lib/consts/settings-cache';
import { backgroundTaskSwrConfig, fetchBackgroundTaskJson } from './background-task-config';
import { GetRefundsResponse, Refund } from '~/lib/api/me/types';
import { getApiPath } from '~/lib/api/me/get-api-path';
import useSWR from 'swr';
import { useEffect } from 'react';

const useSupportBackgroundTask = () => {
  const { session } = useAnalytics();
  const { tenant, settings } = useTenant();
  const { user } = useAuth();

  const { data } = useSWR<Refund[]>(
    SettingsCache.settings.Features.includes('Support') ? `${tenant}/refunds/background` : null,
    async () => {
      const res = await fetchBackgroundTaskJson<GetRefundsResponse>(
        authenticatedFetchWithTenantAnalytics(user, tenant, settings, session, getApiPath(tenant, `/refund`)),
        'refunds'
      );

      if (res?.success && res.result) {
        return res.result.refunds;
      }
      return null;
    },
    backgroundTaskSwrConfig
  );

  useEffect(() => {
    if (data?.length > 0) {
      data.forEach((x) => {
        if (!ExtendedOrderCache.refundOrderLineIds.find((c) => c.orderlineId.toString() === x.orderLineId.toString())) {
          const created = new Date(x.created);
          ExtendedOrderCache.refundOrderLineIds.push({
            orderlineId: x.orderLineId.toString(),
            created: isNaN(created.getTime()) ? undefined : created,
            status: x.status,
            amount: x.amount
          });
        }
      });
    }
  }, [data]);

  return data;
};

export default useSupportBackgroundTask;
